import { IntegracaoFoodyDeliveryActionsTypes, type IntegracaoFoodyDeliveryActions } from "./integracaoFoodyDeliveryActions"
import { IntegracaoFoodyDeliveryInicial, type IntegracaoFoodyDeliveryModel } from "../models/integracaoFoodyDeliveryModel"

export function integracaoFoodyDeliveryReducer(
    state: IntegracaoFoodyDeliveryModel = IntegracaoFoodyDeliveryInicial,
    action: IntegracaoFoodyDeliveryActions
): IntegracaoFoodyDeliveryModel {
    switch (action.type) {
        case IntegracaoFoodyDeliveryActionsTypes.CARREGAR:
            return {
                ...state,
                token: action.payload.token,
                erros: action.payload.erros,
                integracaoAtiva: null,
                mensagemTeste: null,
            }

        case IntegracaoFoodyDeliveryActionsTypes.ATUALIZAR_TOKEN:
            return { ...state, token: action.payload }

        case IntegracaoFoodyDeliveryActionsTypes.ATUALIZAR_ERROS:
            return { ...state, erros: action.payload }

        case IntegracaoFoodyDeliveryActionsTypes.REGISTRAR_TESTE:
            return {
                ...state,
                integracaoAtiva: action.payload.ativa,
                mensagemTeste: action.payload.mensagem,
                erros: action.payload.erros,
            }

        case IntegracaoFoodyDeliveryActionsTypes.LIMPAR_ERROS:
            return { ...state, erros: [] }

        default:
            return state
    }
}
